/**
 * LayerdevSidebar
 * - Architecture OOP
 * - Accessible
 * - Focus trap
 */

class LayerdevSidebar {
    /**
     * @param {Object} options
     * @param {string} options.sidebarSelector
     * @param {string} options.openButtonsSelector
     */
    constructor({
        sidebarSelector = ".halo-collection-content .page-sidebar",
        openButtonsSelector = "[data-open-sidebar]",
        closeButtonText = (document.documentElement.getAttribute("data-voir-resultats")
      || "Voir les résultats"),
    } = {}) {

        this.options = { sidebarSelector, openButtonsSelector, closeButtonText };
        this.sidebar = document.querySelector(sidebarSelector);
        if (!this.sidebar) {
            console.warn(`[LayerdevSidebar] Sidebar not found: ${sidebarSelector}`);
            return;
        }

        // State
        this.isOpen = false;
        this.sidebarDetached = false;

        // Rebuild UI
        this.detachSidebar();
        this.addCloseButton(closeButtonText);

        // Bind triggers
        this.bindOpenButtons(openButtonsSelector);
        this.bindKeyboardEvents();

        // Accessibility
        this.applyA11y();
    }

    /** Déplace la sidebar dans <body> */
    detachSidebar() {
        if (this.sidebarDetached) return;
        this.sidebarDetached = true;

        const cloned = this.sidebar.cloneNode(true);
        cloned.classList.add("portal-fixed-sidebar");
        cloned.classList.add('layerdev-cs-sd_cl');

        this.sidebar.remove();
        document.body.appendChild(cloned);
        this.sidebar = cloned;
    }

    /** Ajoute bouton "Voir les résultats" */
    addCloseButton(label) {
        const wrapper = document.createElement("div");
        wrapper.className = "wp-btn-sidebar_see_results";

        const button = document.createElement("button");
        button.className = "button btn-sidebar_see_results";
        button.textContent = label;
        button.addEventListener("click", () => this.close());

        wrapper.appendChild(button);
        this.sidebar.appendChild(wrapper);

        this.closeButton = button;
    }

    /** Bind des boutons d'ouverture */
    bindOpenButtons(selector) {
        this.openButtons = document.querySelectorAll(selector);
        this.openButtons.forEach(btn => btn.addEventListener("click", e => {
            e.preventDefault();
            this.open();
        }));
    }

    /** Escape key handling */
    bindKeyboardEvents() {
        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && this.isOpen) {
                this.close();
            }
        });
    }

    /** Accessibilité */
    applyA11y() {
        this.sidebar.setAttribute("role", "dialog");
        this.sidebar.setAttribute("aria-modal", "true");
        this.sidebar.setAttribute("tabindex", "-1");
    }

    /** Ouvre */
    open() {
        this.isOpen = true;
        document.body.classList.add("open-mobile-sidebar");

        // focus trap start
        setTimeout(() => this.sidebar.focus(), 50);
    }

    /** Ferme */
    close() {
        this.isOpen = false;
        document.body.classList.remove("open-mobile-sidebar");
    }

    /** Toggle */
    toggle() {
        this.isOpen ? this.close() : this.open();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new LayerdevSidebar();
});
